import React from 'react';
import HubspotIcon from './HubspotIcon';
interface SyncStatusProps {
  status: 'Synced' | 'Not Synced';
}
const SyncStatus: React.FC<SyncStatusProps> = ({
  status
}) => {
  const isSynced = status === 'Synced';
  return <div className="flex items-center gap-1.5" data-id="element-342">
      <HubspotIcon className={isSynced ? 'text-green-600' : 'text-red-500'} size={14} data-id="element-343" />
      <span className={`text-xs font-medium ${isSynced ? 'text-green-600' : 'text-red-500'}`} data-id="element-344">
        {status}
      </span>
    </div>;
};
export default SyncStatus;